import { getGuessStatuses } from "../../lib/statuses";
import { Cell } from "./Cell";

type Props = {
  guess: string;
};

type RowProps = Props & { solution: string };

export const CompletedRow = ({ guess, solution }: RowProps) => {
  const statuses = getGuessStatuses(guess, solution);

  return (
    <div className="grid-row">
      {guess.split("").map((letter, i) => (
        <Cell key={i} value={letter} status={statuses[i]} />
      ))}
    </div>
  );
};
